import { useEffect } from 'react';

export const useScrollTop = (key) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [key]);
};
